import type React from "react";
import { createContext, type ReactNode, use, useEffect, useMemo, useState } from "react";
import { updateSettings } from "../db";

interface TabContextType {
    selectedTab: string;
    setSelectedTab: (tab: string) => void;
    selectedSearchTab: string;
    setSelectedSearchTab: (tab: string) => void;
}

const defaultContextValue: TabContextType = {
    selectedTab: "combined",
    setSelectedTab: () => {},
    selectedSearchTab: "All",
    setSelectedSearchTab: () => {},
};

const TabContext = createContext(defaultContextValue);

interface TabProviderProps {
    children: ReactNode;
}

export const TabProvider: React.FC<TabProviderProps> = ({ children }) => {
    const [selectedTab, setSelectedTab] = useState<string>(() => {
        return "combined";
    });
    const [selectedSearchTab, setSelectedSearchTab] = useState<string>(() => {
        const preferences = localStorage.getItem("chatPreferences");
        return preferences ? JSON.parse(preferences).searchTab : "All";
    });

    useEffect(() => {
        localStorage.setItem("selectedTab", selectedTab);
        updateSettings("chat_vector_index", selectedTab);
    }, [selectedTab]);

    useEffect(() => {
        localStorage.setItem("selectedSearchTab", selectedSearchTab);
    }, [selectedSearchTab]);

    const value = useMemo(
        () => ({
            selectedTab,
            setSelectedTab,
            selectedSearchTab,
            setSelectedSearchTab,
        }),
        [selectedTab, selectedSearchTab],
    );

    return <TabContext value={value}>{children}</TabContext>;
};

export const useTab = () => use(TabContext);
